import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import StatementExpenELe from '../../IITTP/StatementExpenditure/StatementExpenELe'


function Main() {
    return (
      <>
          <Header/>
        <Breadcrumb title="Home" subtitle="Statement of Expenditure"/>
        <StatementExpenELe />
      </>
    )
  }
  
  export default Main